// extracted by mini-css-extract-plugin
module.exports = {"container":"Timer_container__Bq6w2","time":"Timer_time__K3XXv"};